// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3TVb0","errorLogs":"styles_errorLogs__7mYNE"};